import styled, { css } from 'styled-components';

const AvatarStyled = styled.div`
  ${() => {
    return css`
      background-color: var(--color-blue);
      border: 0.125em solid var(--color-blue);
      width: 2em;
      height: 2em;
      border-radius: 50%;
      overflow: hidden;
      position: relative;
      .avatar-img {
        position: absolute;
        object-fit: cover;
        inset: 0;
        width: 100%;
        height: 100%;
        background-color: var(--color-blue);
      }
    `;
  }}
`;

export default AvatarStyled;
